import React, { Component } from "react";
import Select from 'react-select';
import { CountryJson } from '../../../_constants/country';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { notification } from 'antd';
import { withRouter } from 'react-router-dom';
import PlacesAutocomplete, { geocodeByAddress, getLatLng} from "react-places-autocomplete";
import { addAdminCityAction } from '../../../actions/Admin/CountryCityAction';
import $ from 'jquery'

var componentForm = {
    locality: 'long_name', 
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
    lat: "lat",
    lng: "lng"
};

class LocationSearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
        	Country:{},
        	State:{},
            city: "", 
            address: "", 
            currentCity:"",
            currentCuntryCode:"",
            dataSave:false,
            coordinate:[],
            requestServer:false,
            countryError:false,
            defaultSet:true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.addCityCountry = this.addCityCountry.bind(this);
    }


    componentWillMount() {
    	console.log("props", this.props);
    }


    componentWillReceiveProps(nextProps) {
       
        if (nextProps && nextProps.props.cityCountryAdd && nextProps.props.cityCountryAdd.statusCode === 200&&this.state.requestServer) {
            notification.success({
                message: nextProps.props.cityCountryAdd.msg,
                className:'successNotification',
                duration: 3
            });

            this.setState({
                requestServer: false,
            })
            this.props.props.history.push({
                pathname: "/admin/view-city",
            });
        }
    }


    addCityCountry(){
    	if(this.state.dataSave){
    		let Obj ={
    			"country":this.state.Country,
    			"state":this.state.State,
    			"city":this.state.address,
    			"coordinates":this.state.coordinate
    		}
    		this.setState({
    			requestServer:true
    		})
    		this.props.props.addAdminCityAction(Obj)
		}
	}
    


    handleChange = address => {
    	if(this.state.currentCuntryCode===""||this.state.currentCuntryCode===undefined){
        	this.setState({ countryError:true });
    	}else{
        	this.setState({ address });
    	}
    };


    handleSelect =  (address, placeId) => {
        console.log("address", address);
        let coordinate=[];
        geocodeByAddress(address)
            .then(async results => {
                console.log("results[0]", results[0]);
                await getLatLng(results[0])
                    .then(latLng => {
                        console.log("latLng", latLng);
                        coordinate.push(latLng.lng);
                        coordinate.push(latLng.lat);
                    })
                for (var i = 0; i < results[0].address_components.length; i++) {
                    var addressType = results[0].address_components[i].types[0];
                    console.log("addressType", addressType);
                    if (componentForm[addressType]) {

                       if (addressType === 'locality') { 
                            var val = results[0].address_components[i][componentForm[addressType]];
                            this.setState({ "address": val,coordinate:coordinate })
                        }

                         if (addressType === "administrative_area_level_1") { 
                            var label = results[0].address_components[i].long_name;
                            var value = results[0].address_components[i].short_name;
                            let obj ={
                            	label:label,
                            	value:value

                            }
                            this.setState({ State: obj,dataSave:true})
                        }
                    }
                }
            })
            .catch(error => console.error('Error', error));
    };


    findData = () => {
        //this.props.props.reqUestByCity(this.state.address)
    }

    ChangeCity = () => {
        localStorage.setItem("changeCity", true)
       this.setState({
            address:"",
            defaultSet:false
       });
        $("#searchPlace").focus();
    }


    handleChangeSelect = (name, value) => {
    	console.log("value", value);
        this.setState({
            [name]: value,
            currentCuntryCode:value.value,
            dataSave:false,
            countryError:false
        });
    }



    render() {

        const searchOptions = {
            types: ['(cities)'],
            componentRestrictions: { country: this.state.currentCuntryCode }
        }

        return (
				 <div className="row wi100ful">
					  <div className="col-md-3">
						<Select name="Country" 
							className="singup-control"
							value={this.state.Country}
							onChange={this.handleChangeSelect.bind(this, "Country")}
							options={CountryJson}
							placeholder="Select Country"
						/>
						{this.state.countryError&&
							<span className="requiredFiled">Please Select The Country*</span>
						}
					</div>

					<div className="col-md-3">
		               <PlacesAutocomplete
		                className="fnew-control"
		                value={this.state.address}
		                onChange={this.handleChange}
		                onSelect={this.handleSelect}
		                searchOptions={searchOptions}
		            >
	        			{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
	           				 <div className="autocomplete-container wid-reduce wifull">
	              				<div className="input-group">
					                  <input
					                    {...getInputProps({
					                      placeholder: "Search Places",
					                      id:"searchPlace",
					                      className: "location-search-input fnew-contro form-control"
					                    })}
					                  />
	            				</div>

					            <div className="autocomplete-dropdown-container search-suggestion-list">
					              {loading && <div>Loading...</div>}
					              {suggestions.map(suggestion => {
					                const className = suggestion.active
					                  ? "suggestion-item--active"
					                  : "suggestion-item";
					                // inline style for demonstration purpose
					                const style = suggestion.active
					                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
					                  : { backgroundColor: "#ffffff", cursor: "pointer" };
					                return (
					                  <div
					                    {...getSuggestionItemProps(suggestion, {
					                      className,
					                      style
					                    })}
					                  >
					                    <span>{suggestion.description}</span>
					                  </div>
					                );
					              })}
					            </div>
	          				</div>
	        			)} 
      				</PlacesAutocomplete>
                     </div>
                    <div className="col-md-3">
						<Select name="State" 
							className="singup-control"
							value={this.state.State}
							disabled={true}
							placeholder="State"
						/>

      				   </div>
                

             <div className="col-md-3">
      		   <button className="button-clicks" onClick={this.addCityCountry}>Add City</button></div>
      			</div>
        	);
    }
}


class CitySuggestionCountry extends React.Component {
    constructor(props) {
        super(props);
        this.state = { places: [] };
        this.showPlace = this.showPlace.bind(this);
        this.mapRef = React.createRef();
    }

    showPlace(place) {
        this.setState(prevState => ({
            places: [...prevState.places, place]
        }));
        this.mapRef.current.map.setCenter(place.geometry.location);
    }


      
    render() {
        return (
            <div className="map-container"> 
                <LocationSearchInput  className="fnew-control" props={ this.props } onPlaceChanged={this.showPlace} />
            </div>

        );
    }
}

function mapStateToProps(state) {

    	console.log("state.CountryStaeCity.responseCitysugg", state.CountryStaeCity.responseCitysugg);
    return {
    	cityCountryAdd:state.CountryStaeCity.responseCitysugg,
    };
}
export default withLocalize(withRouter(connect(mapStateToProps, {
   // reqUestByCity
   addAdminCityAction
})(CitySuggestionCountry)));


// WEBPACK FOOTER //
// ./src/components/Admin/Layout/CustomeCountrCitySuggestion.js